import { render, staticRenderFns } from "./ListWholesales.vue?vue&type=template&id=dc56181e&scoped=true&"
import script from "./ListWholesales.vue?vue&type=script&lang=ts&"
export * from "./ListWholesales.vue?vue&type=script&lang=ts&"
import style0 from "./ListWholesales.vue?vue&type=style&index=0&id=dc56181e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc56181e",
  null
  
)

export default component.exports